import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { TransportOrderDetailsDto, TransportOrderState } from "../../../models/transport/transportOrder";
import { useAppSelector } from "../../../framework/redux/hooks";

export interface DriverCommentsProps {
    onCommentsChange: (comments: string) => void;
    setEditOrder?: (fields: Partial<TransportOrderDetailsDto>) => void;
    disabled?: boolean;
}

export const DriverComments = ({ onCommentsChange, setEditOrder } : DriverCommentsProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const blue: string = theme.palette.blue.dark;

    const order = useAppSelector(state => state.transportOrderDetails.editingOrder);
    const employeeId = useAppSelector((state) => state.session.id);

    if (!order) return null;

    const editingDisabled = order.state >= TransportOrderState.Cancelled;
    const [localValue, setLocalValue] = React.useState(order.driverComments ?? "");

    useEffect(() => {
        setLocalValue(order.driverComments ?? "");
    }, [order.driverComments]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(e.target.value);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (setEditOrder) {
            setEditOrder({
                ...order,
                driverComments: localValue,
                modifiedEmployeeId: employeeId
            });
        }
        onCommentsChange(localValue);
    };

    return (
        <Box sx={{ p: 2 }} component="form" onSubmit={handleSubmit}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: blue, my: 1 }}>
                {t("transport.order.comment")}
            </Typography>
            <TextField
                placeholder={t("transport.order.comment")}
                rows={2}
                multiline
                fullWidth
                value={localValue}
                onChange={handleChange}
                disabled={editingDisabled}
            /><br />
            {!editingDisabled &&
                <Button
                    sx={{ mt: 1 }}
                    type="submit"
                    variant="contained"
                    color="success"
                >
                    {t("common.save")}
                </Button>
            }
        </Box>
    );
};